import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import ProductApi from './ProductApi';
import ProductActions from './Components/ProductActions';
import ModelLink from '@dex/bubl-dash/src/lib/components/ModelLink/ModelLink';

let settings;

export default settings = {
    key: 'shop/products',
    zone: 'shop',
    path: '/shop/products',
    title: "Products",
    endpoint: ProductApi.endpoint,
    modelName: 'Product',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewProduct"],
    viewCaps: ["viewProduct"],
    createCaps: ["createProduct"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: ProductApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['operator', 'league', 'camp', 'host'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title', 'type', 'price'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "draft", label: "Draft" },
                    { value: "preview", label: "Preview" },
                    { value: "publish", label: "Publish" },
                    { value: "archive", label: "Archive" },
                ],
            },
            {
                label: "Type",
                key: "type",
                type: 'text',
                format: "titleCase",
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model:"Hosts"
            }
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Status",
                key: "status",
                type: 'text',
                format: "titleCase",
            },
            {
                label: "Type",
                key: "type",
                format: "titleCase",
            },
            {
                label: "Price",
                key: "price",
                format: 'number'
            },
            {
                label: "Priority",
                key: "priority",
            },
            {
                label: "Host",
                key: "host",
                format: "modelLink",
            },
            {
                label: "Camp / League / Operator",
                key: "operator.title",
                type: 'text',
                format: "titleCase",
                render: (text, row) => {
                    if (row.operator) return <ModelLink data={row.operator} />;
                    else if (row.league) return <ModelLink data={row.league} />;
                    else if (row.camp) return <ModelLink data={row.camp} />;
                }
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <ProductActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: ProductApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['operator', 'league', 'camp', 'form', 'host'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};